<template>
  <div
    id="app" 
    v-loading="pageLoading"
    element-loading-text=""
    element-loading-background="rgba(255, 255, 255, 0.7)">
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'app',
  components: {
  },
  computed: {
    ...mapState({
      pageLoading: state => state.app.pageLoading
    })
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-width: 1400px;
}
* {
  margin: 0;
}
</style>
